<template>
  <div class="aboutUs">
    <navs></navs>
    <div class="abouts">
      <p class="bigTitle">关于我们</p>
      <p class="smallTitle">ABOUT US</p>
    </div>
    <div class="marT"></div>
    <van-tabs v-model="active" :ellipsis="false" class="tabsBox">
      <van-tab title="企业简介">
        <div>
          <img src="../assets/about-jiu.png" class="companyImg"/>
          <p class="companyIntro">
            携船网是携船网（福建）航运科技有限公司开发、运营的物流产业互联网平台，我们是一家以数据为核心，为水陆货物运输提供多元化产品与服务的科技型企业。平台融合物联网、大数据、云计算、区块链、人工智能等技术，为航运业提供信息技术服务，并延伸交易结算、供应链管理、金融保险、船舶交易、船舶管理、航运大数据等航运生态产业链服务。平台旨在消除当前行业存在的信息不对称、价格不透明、合同不规范、结算不及时等弊端，秉承“规范、创新、诚信、共享”的经营理念，响应国家供给侧改革，推动行业向标准化、可视化、数字化、智能化发展，促进行业降本增效。
          </p>
          <p class="companyIntro">
            携船网自上线以来，不断深入市场挖掘用户需求，产品经过多次迭代更新，取得优异成绩。先后荣获国家级、省市级国家高新技术企业、科技型中心企业、专精特新小巨人、中小微信用企业、服务外包重点企业、重点产业企业等荣誉称号，已发展成为国内水运互联网龙头企业。现有产品线覆盖APP、微信端、车船定位、航运大数据系统及供应链管理系统等，其中IOS版本连续多年蝉联App
            Store“海运”品类第一。截止至2022年6月，平台注册用户达18万多人，注册船舶18000多艘，入驻企业6000多家，并与多家银行、商业保理、融资租赁等金融部门签署战略合作协议，在供应链金融、船舶融资及租赁、交易担保等方面开展广泛合作，为平台产品服务提供有力的金融支撑。
          </p>
        </div>
      </van-tab>
      <van-tab title="公司大事记">
        <div style="margin-top:1.2rem"></div>
        <!--        <div class="compEvents">-->
        <!--          <div class="leftLine">-->
        <!--            <img src="../assets/line.png" />-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <p class="dayTitle">2021年11月</p>-->
        <!--            <p class="titleComp">平台运输交易额突破40亿</p>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="compEvents">
          <div class="leftLine">
            <img src="../assets/line.png"/>
          </div>
          <div>
            <p class="dayTitle">2020年11月</p>
            <p class="titleComp">荣获“抚州数字产业优秀企业”称号</p>
          </div>
        </div>
        <div class="compEvents">
          <div class="leftLine">
            <img src="../assets/line.png"/>
          </div>
          <div>
            <p class="dayTitle">2020年9月</p>
            <p class="titleComp">通过“信息系统安全等级保护”第三级认定</p>
          </div>
        </div>
        <div class="compEvents">
          <div class="leftLine">
            <img src="../assets/line.png"/>
          </div>
          <div>
            <p class="dayTitle">2019年12月</p>
            <p class="titleComp">被认定为国家高新技术企业</p>
          </div>
        </div>
        <div class="compEvents">
          <div class="leftLine">
            <img src="../assets/line.png"/>
          </div>
          <div>
            <p class="dayTitle">2019年12月</p>
            <p class="titleComp">
              被认定为平潭综合实验区2019年“服务外包重点企业”
            </p>
          </div>
        </div>
        <div class="compEvents">
          <div class="leftLine">
            <img src="../assets/line.png"/>
          </div>
          <div>
            <p class="dayTitle">2018年06月</p>
            <p class="titleComp">被认定为“平潭综合实验区科技型中小企业”</p>
          </div>
        </div>
        <div class="compEvents">
          <div class="leftLine">
            <img src="../assets/line.png"/>
          </div>
          <div>
            <p class="dayTitle">2018年02月</p>
            <p class="titleComp">
              被授予平潭综合实验区2016-2017年 “税收贡献奖”
            </p>
          </div>
        </div>
        <div class="compEvents">
          <div class="leftLine">
            <img src="../assets/line.png"/>
          </div>
          <div>
            <p class="dayTitle">2017年10月</p>
            <p class="titleComp">
              获得平潭综合实验区第一批“中小微信用企业”称号
            </p>
          </div>
        </div>
        <div class="compEvents">
          <div class="leftLine">
            <img src="../assets/line.png"/>
          </div>
          <div>
            <p class="dayTitle">2017年09月</p>
            <p class="titleComp">公司第一艘命名携船系列船舶“携船轮” 下水运营</p>
          </div>
        </div>
        <div class="compEvents">
          <div class="leftLine">
            <img src="../assets/line.png"/>
          </div>
          <div>
            <p class="dayTitle">2017年06月</p>
            <p class="titleComp">亮相福建海峡成果交易会，省领导参观指导</p>
          </div>
        </div>
        <div class="compEvents">
          <div class="leftLine">
            <img src="../assets/line.png"/>
          </div>
          <div>
            <p class="dayTitle">2016年09月</p>
            <p class="titleComp">公司第一艘船舶“港联1”下水运营</p>
          </div>
        </div>
        <div class="compEvents">
          <div class="leftLine"></div>
          <div>
            <p class="dayTitle">2016年08月</p>
            <p class="titleComp">
              “携船网” 被平潭综合实验区列为 “5+2” 重点发展项目之一
            </p>
          </div>
        </div>
      </van-tab>
      <van-tab title="经营理念">
        <div class="jyln">
          <span> 秉承“规范、创新、诚信、共享”的经营理念,</span>
          <span>以物流大数据为核心，集聚产业资源，推动行业</span>
          <span>数字化进程，促进行业降本增效。</span>
          <div class="oranginBox"></div>
        </div>
      </van-tab>
      <!--      <van-tab title="战略布局">-->
      <!--        <div class="zlBox"></div>-->
      <!--      </van-tab>-->
      <van-tab title="资质荣誉">
        <van-swipe class="my-swipe" :autoplay="3000">
          <van-swipe-item>
            <div style="margin-top:0.8rem"></div>
            <div class="listBox">
              <div>
                <img src="../assets/rz-21.jpg"/>
                <p>重点产业企业</p>
              </div>
              <div>
                <img src="../assets/rz-22.jpg"/>
                <p>科技型中小企业</p>
              </div>
            </div>
            <div class="listBox">
              <div>
                <img src="../assets/rz-23.jpg"/>
                <p>税收贡献奖</p>
              </div>
              <div>
                <img src="../assets/rz-24.jpg"/>
                <p>中小微金融信用企业</p>
              </div>
            </div>
            <div class="listBox">
              <div>
                <img src="../assets/rz-20.jpg"/>
                <p>国家高新技术企业</p>
              </div>
              <div>
                <img src="../assets/rz-25.jpg"/>
                <p>船舶管理业务经营许可</p>
              </div>
            </div>
            <div class="listBox">
              <div>
                <img src="../assets/rz-5.png"/>
                <p>水路运输许可证</p>
              </div>
              <div>
                <img src="../assets/rz-26.jpg"/>
                <p>道路运输许可证</p>
              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div style="margin-top:0.8rem"></div>
            <div class="listBox" style="margin-top:1rem">
              <div>
                <img src="../assets/rz-19.jpg"/>
                <p>电信增值业务许可证</p>
              </div>
              <div>
                <img src="../assets/szcy.png"/>
                <p>抚州数字产业优秀企业</p>
              </div>
            </div>
            <div class="listBox" style="margin-top:1.8rem">
              <div>
                <img src="../assets/rz-28.jpg"/>
                <p>一种新型船舶定位锚系结构</p>
              </div>
              <div>
                <img src="../assets/rz-27.jpg"/>
                <p>一种船舶货物装载起重装置</p>
              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div style="margin-top:0.8rem"></div>
            <div class="listBox" style="margin-top:1rem">
              <div>
                <img src="../assets/rz-8.png"/>
                <p>携船网APP(IOS版)</p>
              </div>
              <div>
                <img src="../assets/rz-7.png"/>
                <p>携船网APP(Android版)</p>
              </div>

            </div>
            <div class="listBox" style="margin-top:1.8rem">
              <div>
                <img src="../assets/rz-10.png"/>
                <p>携船网保险（安卓版）</p>
              </div>
              <div>
                <img src="../assets/rz-11.png"/>
                <p>携船网保险后端管理软件V1.0.0</p>
              </div>

            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div style="margin-top:0.8rem"></div>
            <div class="listBox" style="margin-top:1rem">
              <div>
                <img src="../assets/rz-12.png"/>
                <p>携船网常规管理软件</p>
              </div>
              <div>
                <img src="../assets/rz-13.png"/>
                <p>携船网船查查管理软件</p>
              </div>

            </div>
            <div class="listBox" style="margin-top:1.8rem">
              <div>
                <img src="../assets/rz-14.png"/>
                <p>携船网港口信息管理软件</p>
              </div>
              <div>
                <img src="../assets/rz-15.png"/>
                <p>携船网竞价系统</p>
              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div style="margin-top:0.8rem"></div>
            <div class="listBox" style="margin-top:1rem">
              <div>
                <img src="../assets/rz-16.png"/>
                <p>携船网信息管理软件</p>
              </div>
              <div>
                <img src="../assets/rz-17.png"/>
                <p>携船网用户管理软件</p>
              </div>
            </div>
            <div class="listBox" style="margin-top:1.8rem">
              <div>
                <img src="../assets/rz-18.png"/>
                <p>携船网约船宝管理软件</p>
              </div>
              <div>
                <img src="../assets/rz-9.png"/>
                <p>携船网保险（IOS版）软著</p>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </van-tab>
    </van-tabs>
    <foot></foot>
    <rightC></rightC>
  </div>
</template>
<script>
import navs from "@/components/nav/head";
import foot from "@/components/nav/footer";
import rightC from "@/components/nav/rightFloat";

export default {
  name: "aboutUs",
  data() {
    return {
      current: 0,
      active: 0
    };
  },
  components: {
    navs,
    foot,
    rightC
  },
  created() {
  }
};
</script>
<style lang="less" rel="stylesheet/less">
@rem: 16rem;
@col-f: #fff;
.abouts {
  width: 100%;
  height: 10rem;
  background: url("../assets/about-b.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: ceil(100%) ceil(100%);
  align-items: center;

  p {
    text-align: center;
    color: @col-f;
    font-size: 22 / @rem;
    padding-top: 3.14rem;
    margin: 0;
  }

  .smallTitle {
    text-align: center;
    color: @col-f;
    font-size: 12 / @rem;
    padding-top: 10 / @rem;
  }
}

.marT {
  margin-top: 12 / @rem;
  border: none;
}

.companyImg {
  width: 190 / @rem;
  display: block;
  margin: 20 / @rem auto;
}

.companyIntro {
  font-size: 11 / @rem;
  color: #333;
  padding-left: 20 / @rem;
  padding-right: 20 / @rem;
  text-align: justify;
  text-indent: 28px;
}

.compEvents {
  display: flex;
  justify-content: flex-start;
  margin-left: 14 / @rem;

  .leftLine {
    margin-right: 0.8rem;
    width: 12 / @rem;
    padding-top: 11 / @rem;
    text-align: center;
    background-image: url("../assets/proicon.png");
    background-repeat: no-repeat;
    background-position: left top;
    background-size: 11 / @rem 11 / @rem;
    height: 3.4rem;

    img {
      display: block;
      margin: 0 auto;
      height: 100%;
      // width:1px
    }
  }

  .dayTitle {
    color: #198cff;
    font-size: 12 / @rem;
    margin: 0;
    margin-top: -0.2rem;
  }

  .titleComp {
    color: #333;
    font-size: 12 / @rem;
    margin-top: 0.1rem;
  }
}

.listBox {
  display: flex;
  justify-content: space-between;

  div {
    width: 50%;
    text-align: center;

    img {
      width: 120 / @rem;
      display: block;
      margin: 0.4rem auto;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.15);
    }

    p {
      font-size: 10 / @rem;
      color: #3d3d3d;
    }
  }
}

.oranginBox {
  width: 100%;
  background-image: url("../assets/jyln.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 90% 90%;
  height: 200 / @rem;
  margin-top: 60  / @rem;
  margin-bottom: 60  / @rem;
}

.zlBox {
  width: 100%;
  background-image: url("../assets/zlbj.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% auto;
  height: 22rem;
}

.my-swipe {
  height: 32.2rem;
}

.jyln {
  margin-top: 35 / @rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12 / @rem;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue